import { createFileRoute } from "@tanstack/react-router"

import Dashboard from "@/components/dashboard"

export const Route = createFileRoute("/$dealership/dashboard")({
  staticData: {
    breadcrumb: "Dashboard",
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Dashboard />
}
